import { Box, Grid } from '@mui/material';
import { itIT, enUS } from '@mui/x-data-grid/locales';
import { DataGrid } from '@mui/x-data-grid';

const CustomTable = (props) => {
  var lng = enUS;
  if(props.userLng == 'it'){
      lng = itIT;
  }
  return (
      <div>
          {
              props.rows == [] || props.rows === undefined ? <div>Loading...</div> : 
              props.enableSelection && props.tableHeight !== undefined && props.tableHeight !== null && props.tableHeight > 0 ? 
                  <Box sx={{ height: `${props.tableHeight}px`}}>
                      <DataGrid
                      localeText={lng.components.MuiDataGrid.defaultProps.localeText}
                      getRowId={(r) => r[props.id]}
                      columns={props.columns}
                      rows={props.rows}
                      rowHeight={props.rowHeight}   
                      headerHeight={props.headerHeight}
                      hideFooter
                      disableColumnSelector
                      disableColumnMenu
                      disableColumnFilter
                      disableSelectionOnClick
                      disableRowSelectionOnClick
                      checkboxSelection
                      onRowSelectionModelChange={(ids) => {
                          props.setSelectedRows(ids)
                      }}
                      onSortModelChange={(model) => {
                          if(props.sortModelChange !== undefined){
                              props.sortModelChange(model);
                          }
                      }}
                      rowSelectionModel={props.selectedRows}
                      getRowClassName={props.getRowClassName}
                      />
                  </Box>
              :
              props.tableHeight !== undefined && props.tableHeight !== null && props.tableHeight > 0 
              ?
              <Box sx={{ height: `${props.tableHeight}px`}}>
                  <DataGrid
                  localeText={lng.components.MuiDataGrid.defaultProps.localeText}
                  getRowId={(r) => r[props.id]}
                  columns={props.columns}
                  rows={props.rows}
                  rowHeight={props.rowHeight}   
                  headerHeight={props.headerHeight}
                  hideFooter
                  disableColumnSelector
                  disableColumnMenu
                  disableColumnFilter
                  disableSelectionOnClick
                  disableRowSelectionOnClick
                  getRowClassName={props.getRowClassName}
                  onSortModelChange={(model) => {
                      if(props.sortModelChange !== undefined){
                          props.sortModelChange(model);
                      }
                  }}
                  />
              </Box>
              :
              <DataGrid
              localeText={lng.components.MuiDataGrid.defaultProps.localeText}
              getRowId={(r) => r[props.id]}
              columns={props.columns}
              rows={props.rows}
              autoHeight
              rowHeight={props.rowHeight}   
              headerHeight={props.headerHeight}
              hideFooter
              disableColumnSelector
              disableColumnMenu
              disableColumnFilter
              disableSelectionOnClick
              disableRowSelectionOnClick
              onSortModelChange={(model) => {
                  if(props.sortModelChange !== undefined){
                      props.sortModelChange(model);
                  }
              }}
               getRowClassName={props.getRowClassName}
              />
          }
      </div>
  );
}

export default CustomTable